module.exports = __webpack_public_path__ + "media/images/partners/helen-keller-int-30fb654479f08754427ac9c8643d100b.png";